import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Grid, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
import capRegistrationActions from "../../redux/capRegistration/actions";

export default function CapCandidatureTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { backofficeTokenDetails } = useSelector(state => state.authReducer);
  const { capCandidatures } = useSelector(state => state.capReducer)
  console.log(capCandidatures, 'capCandidatures')
  // let candDocData = [ {
  //     candidatureid: 1,
  //     candidature:"All Candidates",
  //     documents:"SSLC,HSc,Degree",
  //     Documentid:[]
  // }]
  const { capDocuments } = useSelector(state => state.capReducer)
  const [tableData, setTableData] = useState([

  ]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const createTabledata = (capCandidatures) => {
    if (!capCandidatures || !Array.isArray(capCandidatures)) return;

    let data = capCandidatures.map((obj, index) => ({
      id: index + 1,
      candidatureid: obj.candidatureid,
      candidature: obj.candidature || "N/A",
      documents: obj.document_names,
      enable: (
        <Radio
          checked={obj.status === "1"}
          onClick={() => handleActive(obj.status, "1", obj.candidatureid,obj)}
        />
      ),
      disable: (
        <Radio
          checked={obj.status === "0"}
          onClick={() => handleActive(obj.status, "0", obj.candidatureid,obj)}
        />
      ),
    }));

    setTableData(data);
  };
  useEffect(()=>{
dispatch({type:capRegistrationActions.GET_CAP_CANDIDATURE})
  },[])
  useEffect(() => {
    createTabledata(capCandidatures)
  }, [capCandidatures]);


  const handleActive = (active, type, eligibilitycriteriaid,exdata) => {
    if (type !== active) {
      let data = {
        ...exdata,
        userid: backofficeTokenDetails?.id,
        status: type
      }
      dispatch({
        type: capRegistrationActions.UPDATE_CAP_CANDIDATURE,
        payload: { data: data },
      });
    }
  }






  useEffect(() => {
    dispatch({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT })
  }, [])
  const tableKeys = [
    {
      name: "S.No",
      accessor: "id",
      sortOption: false,
    },
    {
      name: "Candidature Name",
      accessor: "candidature",
      sortOption: false,
    },
    {
      name: "Candidature Documents",
      accessor: "documents",
      sortOption: false,
    },
    {
      name: "Enable",
      accessor: "enable",
      sortOption: false,

    },
    {
      name: "Disable",
      accessor: "disable",
      sortOption: false,
    },
  ];



  const handleCandidatureUpdate = (val) => {
    console.log(val, 'Val')
    navigate(`/${Cookies.get("mhet_mst_project")}/cap-candidature-document?page=updatecapcandidaturedocument`, { state: { id: val } });
  }



  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  return (
    <Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"candidature-documentlist"}
        handleCandidatureUpdate={handleCandidatureUpdate}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
  );
}
